import { Component, Inject, Input, AfterViewInit} from 'ng-metadata/core';
import { QuickLink } from './quickLink.service';
import { PrimoResponse } from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import { getBackendSystem } from '../../appConfig/appConfigForward';
import { beacon, PrimolyticsService } from "../../analytics/primolytics.service";


const get = require('lodash/get');

@Component({
    selector: 'prm-quick-link',
    templateUrl: 'components/search/quickLink/quick-link.html'
})

export class PrmQuickLink {

    private recordLinks: Object[];
    public iconType: any;
    public iconsToHideInSections: any;
    @Input() public item: PrimoResponse.IDoc;
    @Input() private displaySection: string;
    @Input() isFullDisplay: boolean;//true in full display and false in brief result page 


    constructor(@Inject('availabilityLineIcons') private availabilityLineIcons: Object[],
        private linksService: QuickLink,
        private primolyticsService: PrimolyticsService,
        @Inject('$scope') private $scope: ng.IScope,
        @Inject('$element') private $element: ng.IRootElementService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService) {
        this.iconType = {
            PDF: "pdf-link",
            HTML: "html-link"
        };

        this.iconsToHideInSections = {
            Links: true
        };
    }

    ngOnInit() {
        this.recordLinks = [];
        this.updateQuickLink();
        this.showNoLinksErrorlabel = true
    }

    ngAfterViewInit() {
        this.$timeout(() => {
            this.removeRollButton();
        }, 0);
    }

    set showNoLinksErrorlabel(value: boolean) {
        this.linksService.showNoLinksErrorlabel = value;
    }

    get showNoLinksErrorlabel() {
        return this.linksService.showNoLinksErrorlabel;
    }

    private isToDisplayIcons() {
        return this.iconsToHideInSections[this.displaySection] ? false : true;
    }

    private iconByType(link) {
        if (link.type) {
            return this.iconType[link.type];
        }
        return '';
    }

    public hasQuickLink() {
        return this.linksService.isQuickLinksAvailable(this.item) || this.linksService.unpaywallEnabled;
    }

    public getQuickLinks() {

        let unpaywallLinks = this.linksService.unpaywallLinks;
        // Use quickLink if exists
        if (this.recordLinks.length != 0) {
            if (this.isFullDisplay) {
                 this.showNoLinksErrorlabel = false;
            }
            return this.recordLinks;
        }


        // Use Unpaywall if exists (in case QuickLink not exists)
        if (unpaywallLinks) {

            let recordid = this.item.pnx.control.recordid;
            if (unpaywallLinks[recordid] != undefined) {
                if (unpaywallLinks[recordid].length) {
                    if (this.isFullDisplay) {
                        if (this.showNoLinksErrorlabel) {
                            this.showNoLinksErrorlabel = false;
                        }
                    }
                }
             }
            if (angular.isArray(recordid)) {
                recordid = recordid[0];
            }
            if (unpaywallLinks[recordid]) {
                return unpaywallLinks[recordid];
            } else if (get(this.item, 'pnx.links.linktopdf[0]', false)) {
                unpaywallLinks[recordid] = this.linksService.getQuickLinksFromPnx(this.item);
                return unpaywallLinks[recordid];
            }
        }
    }

    updateQuickLink() {

        if (this.linksService.isQuickLinksAvailable(this.item)) {
            this.recordLinks = this.linksService.getQuickLinksFromPnx(this.item);
        }
    }


    public runQuickLinks(link) {
        if (link.sourceType === "unpaywall") {
            this.reportBeaconUnpaywallPDF();
        } else {
            if (link.type === "PDF") {
                this.reportBeaconQuickLinkPDF();
            }
            if (link.type === "HTML") {
                this.reportBeaconQuickLinkHTML();
            }
        }
    }

    private removeRollButton() {
        let elem = this.$element[0];
        if (elem) {
            elem.removeAttribute('role');
        }
    }

    @beacon({ 'p': 'linksService', 'op': 'QuicklinkPDF' })
    public reportBeaconQuickLinkPDF() {
    }

    @beacon({ 'p': 'linksService', 'op': 'QuicklinkHTML' })
    public reportBeaconQuickLinkHTML() {
    }

    @beacon({ 'p': 'linksService', 'op': 'UnpaywallPDF' })
    public reportBeaconUnpaywallPDF() {
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/quickLink/quickLink.directive.ts